<template>
  <v-card-charts-dashboard
    :title="chartDataComputed.title"
    :options="chartDataComputed.options"
    :deep-copy-on-update="chartDataComputed.deepCopyOnUpdate"
    :is-loading="chartDataComputed.loading"
  />
</template>

<script>
export default {
  name: "DashboardServicosVisaoAneelCardSituacaoSolicitacoes",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dados: {
      type: Object,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    chartOptions: {},
    chartData: {
      title: "Situação das Solicitações",
      deepCopyOnUpdate: false,
    },
  }),
  mounted() {
    this.setChartOptions();
  },
  methods: {
    setChartOptions() {
      this.chartOptions = {
        chart: {
          type: "pie",
          height: 250,
          animation: false,
        },
        // colors: [],
        plotOptions: {
          series: {
            animation: false,
          },
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              distance: 30,
              formatter: function() {
                return `${this.point.name}: ${parseFloat(
                  this.point.y,
                ).toLocaleString("pt-BR")}`;
                // return parseFloat(this.point.y).toLocaleString('pt-BR')
              },
            },
            showInLegend: true,
          },
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: false },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [
          {
            name: "Valor",
            colorByPoint: true,
            innerSize: "75%",
            animation: false,
            data: [
              { name: "Serviços Suspensos", y: this.dados.servicos_suspensos },
              {
                name: "Serviços Pendentes Fora Prazo",
                y: this.dados.servicos_pendentes_fora_prazo,
              },
              {
                name: "Serviços Pendentes no Prazo",
                y: this.dados.servicos_pendentes_no_prazo,
              },
            ],
          },
        ],
        exporting: this.exportingOptions,
      };
    },
  },
  computed: {
    chartDataComputed() {
      return {
        ...this.chartData,
        options: this.chartOptions,
        loading: this.loading,
      };
    },
  },
  watch: {
    dados() {
      this.setChartOptions();
    },
    loading(val) {
      if (!val) {
        this.setChartOptions();
      }
    },
  },
};
</script>

<style></style>
